export const MOBILE_MEDIA_QUERY =
  'only screen and (max-width: 640px) and (orientation: portrait), only screen and (max-height: 640px) and (max-width: 640px) and (orientation: landscape)';
export const TABLET_MEDIA_QUERY =
  'only screen and (max-width: 1025px) and (orientation: portrait), only screen and (max-height: 1025px) and (max-width: 1025px) and (orientation: landscape)';
export const FEED_PAGE_SIZE = 100;
export const FEED_CALL_LIMIT_SIZE = FEED_PAGE_SIZE * 5;
export const EMOJIS = ['👍', '🧡', '😂', '😮', '😔', '😠'];
